export default __webpack_public_path__ + "static/media/fastclix_lancing_kit@2x.45b5b740.webp";